import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  DOCUMENT,
  inject,
  input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { environment } from '@environment';

@Component({
  selector: 'app-stripe',
  imports: [],
  templateUrl: './stripe.component.html',
  styleUrl: './stripe.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class StripeComponent implements OnInit, OnDestroy {
  email = input();

  private script: HTMLScriptElement | undefined;

  private renderer: Renderer2 = inject(Renderer2);
  private document: Document = inject(DOCUMENT);

  pricingTableId = environment.stripe.tableId;
  publishableKey = environment.stripe.tableKey;

  ngOnInit(): void {
    this.injectScript('https://js.stripe.com/v3/pricing-table.js');
  }

  public injectScript(src: string): void {
    this.script = this.renderer.createElement('script');
    this.renderer.setAttribute(this.script, 'src', src);
    this.renderer.appendChild(this.document.body, this.script);
  }

  ngOnDestroy(): void {
    if (this.script) {
      this.renderer.removeChild(this.document.body, this.script);
    }
  }
}
